export default __webpack_public_path__ + "static/media/Group 86.bfc3cce8.svg";